const menutypes = [
  {type : 1, class : 'el-icon-menu'},
  {type : 2, class : 'el-icon-message'},
  {type : 3, class : 'el-icon-setting'},
  {type : 4, class : 'el-icon-date'},
  {type : 5, class : 'el-icon-info'},
  {type : 6, class : 'el-icon-star-on'},
  {type : 7, class : 'el-icon-document'}
]

var menutypesmixin = {
  methods: {
    getMenuClass(type) {
      if(type) {
        let result = menutypes.find( a => { return a.type === type; });
        if(result)
          return result.class;
      }
      return '';
    }
  }
}

export default menutypesmixin;



// WEBPACK FOOTER //
// ./src/api/types/menu.js